import callApiAxiosClient from '../../axios/axios_client';
import { getDetectionByGuidResponse } from '../../models';

async function getDetectionByGuid(
  guid: string
): Promise<getDetectionByGuidResponse> {
  const token = JSON.parse(localStorage.getItem('user')!);
  const authorization = 'Bearer ' + token.token;
  return callApiAxiosClient<getDetectionByGuidResponse>({
    method: 'get',
    url: 'detections/get-detection-by-guid',
    headers: {
      'Content-Type': 'Application/json',
      Authorization: authorization,
    },
    params: {
      guid: guid,
    },
  });
}
export default getDetectionByGuid;
